/**
 * DTO for Research Dashboard Group Overview Alerts
 */

export type AlertTab = 'weartime' | 'ecg' | 'questionnaire'

export interface AlertDetailRow {
  tab: AlertTab
  detail: string
  date: string
}

export interface UserAlert {
  userId: string
  totalAlerts: number
  dateSynced: string
  dateLastEcg?: string
}

export interface GroupOverviewAlertsDTO {
  alerts: UserAlert[]
  alertDetailsByUser: Record<string, AlertDetailRow[]>
}

/**
 * Transform the API response to the component's expected format
 * (converts ISO date strings to Date objects)
 */
export interface UserAlertWithDates {
  userId: string
  totalAlerts: number
  dateSynced: Date
  dateLastEcg?: Date
}

export const transformAlertsResponse = (
  response: GroupOverviewAlertsDTO
): {
  alerts: UserAlertWithDates[]
  alertDetailsByUser: Record<string, AlertDetailRow[]>
} => ({
  alerts: response.alerts.map((alert) => ({
    userId: alert.userId,
    totalAlerts: alert.totalAlerts,
    dateSynced: new Date(alert.dateSynced),
    dateLastEcg: alert.dateLastEcg != null ? new Date(alert.dateLastEcg) : undefined
  })),
  alertDetailsByUser: response.alertDetailsByUser
})
